__turbopack_context__.v({
  "container": "_2zHbYW_container",
  "empty": "_2zHbYW_empty",
  "item": "_2zHbYW_item",
  "itemBody": "_2zHbYW_itemBody",
  "itemDetails": "_2zHbYW_itemDetails",
  "itemHeading": "_2zHbYW_itemHeading",
  "list": "_2zHbYW_list",
  "section": "_2zHbYW_section",
  "title": "_2zHbYW_title",
});
